import React, {FC} from 'react';
import BaseButton from '../Button';

interface IntroButton {
    onClick: any,
    children: string
}

const IntroButton: FC<IntroButton> = ({onClick, children}) => {
    return (
        <BaseButton
            isFullWidth={true}
            onClick={onClick}
            isIntroButton={true}
        >
            {children}
        </BaseButton>
    )
};

export default IntroButton;
